/**
 * Zoom Meeting SDK signature via Medplum Bot (`zoom-signature`).
 *
 * Bot identifier must match `medplum-server/scripts/shared/register-zoom-signature-bot.ts`.
 */

import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { Identifier } from '@medplum/fhirtypes';

export const ZOOM_SIGNATURE_BOT_IDENTIFIER = {
  system: 'https://unify.health/bots',
  value: 'zoom-signature',
} as const;

export function getZoomSignatureBotExecuteTarget(): string | Identifier {
  const id = import.meta.env.VITE_MEDPLUM_ZOOM_SIGNATURE_BOT_ID?.trim();
  if (id) {
    return id;
  }
  const system =
    import.meta.env.VITE_MEDPLUM_ZOOM_SIGNATURE_BOT_IDENTIFIER_SYSTEM?.trim() ??
    ZOOM_SIGNATURE_BOT_IDENTIFIER.system;
  const value =
    import.meta.env.VITE_MEDPLUM_ZOOM_SIGNATURE_BOT_IDENTIFIER_VALUE?.trim() ??
    ZOOM_SIGNATURE_BOT_IDENTIFIER.value;
  return { system, value };
}

export async function fetchZoomSignatureFromBot(
  medplum: MedplumClient,
  meetingNumber: string,
  role: number,
): Promise<string> {
  const result = await medplum.executeBot(
    getZoomSignatureBotExecuteTarget(),
    { meetingNumber, role },
    ContentType.JSON,
  );
  const signature = (result as { signature?: string })?.signature;
  if (!signature || typeof signature !== 'string') {
    throw new Error('Zoom signature bot returned no signature');
  }
  return signature;
}
